import { render } from "./DexBodyRow.vue?vue&type=template&id=7b12b887"
import script from "./DexBodyRow.vue?vue&type=script&lang=js"
export * from "./DexBodyRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__